<template>
<div class="editor_container page-wrap">
  <div class="header-logo">
    <router-link to="/">
      <img alt="beurer logo" src="@/assets/logo_beurer.png">
    </router-link>
    <div class="breadcrumbs-header">
      <router-link :to="'/'"> Home </router-link> > <router-link :to="`/app/${this.app}/`"> {{ this.app }} app settings </router-link> > {{ this.category }} > {{ this.langName }}
    </div>
  </div>
  <div class="editor_container__component">
    <TheSidebar />
    <TheTextEditor :simlifiedFormatting="this.isSimplifiedFormatting()" :language="this.langCode" :category="this.category" />
  </div>
</div>
</template>

<script>
import {
  createNamespacedHelpers
} from 'vuex'
import {
  appActions,
  appMutations
} from '@/constants/'
import TheSidebar from '@/components/TheSidebar'
import TheTextEditor from '@/components/TheTextEditor'
import ApiService from '@/services/ApiService'

const {
  mapState
} = createNamespacedHelpers('applicationState')

export default {
  name: 'editorcontainer',
  components: {
    TheTextEditor,
    TheSidebar
  },
  data () {
    return {
      app: this.$route.params.app,
      langCode: this.$route.params.langCode,
      langName: '',
      category: this.$route.params.category,
      apiService: new ApiService()
    }
  },
  methods: {
    getLanguageName (lang) {
      return this.$i18n.messages[lang].message.languageFullName === undefined ? 'unknown' : this.$i18n.messages[lang].message.languageFullName
    },
    setLangName (lang) {
      this.langName = this.$i18n.messages[lang].message.languageFullName === undefined ? 'unknown' : this.$i18n.messages[lang].message.languageFullName
    },

    isSimplifiedFormatting () {
      let appNamesStr = process.env.VUE_APP_APPS_WITH_SIMPLIFIED_FORMATTING

      if (appNamesStr) {
        let appNames = appNamesStr.split(',')

        return appNames.length > 0 && appNames.includes(this.app)
      }

      return false
    }

  },
  mounted () {
    this.langName = this.getLanguageName(this.$route.params.langCode)

    this.$store.dispatch('applicationState/' + appActions.UPDATE_TEXT_FROM_API, {
      url: this.$route.params.app + '/' + this.$route.params.category + '/' + this.$route.params.langCode
    })

    // Subscribe to the mutation in case another component modifies the state
    this.$store.subscribe(mutation => {
      if (mutation.type === 'applicationState/' + appMutations.SET_TEXT_FROM_API) {
        // console.log('mutation: SET_TEXT_FROM_API')
      }
    })
  },
  watch: {
    '$route' (to, from) {
      this.langCode = to.params.langCode
      this.setLangName(to.params.langCode)
    }
  },
  computed: {
    ...mapState({
      textContent: state => state.textFromAPI.text
    })
  }
}
</script>

<style lang="scss">
@import '@/scss/main.scss';

.editor_container {
  margin: 0 rem(30) rem(40) rem(30);
  display: flex;
  flex-flow: row wrap;

  @include breakpoint(tablet) {
    flex-flow: column nowrap;
  }

  .header-logo {
    display: inline-block;
    margin: rem(40) rem(14) rem(20) 0;
    padding: rem(10) rem(15);
    width: 100%;
    height: auto;
    text-align: left;

    img {
      max-width: rem(120);
      max-height: rem(60);
    }
  }

  .breadcrumbs-header {
    display: inline-block;
    margin: rem(10) auto auto 0;
    text-align: left;
    font-weight: bold;
    font-size: rem(14);
    color: $dark-light;

    a {
      text-decoration: none;
      color: $primary;
      padding: rem(4);
      border-radius: rem(5);
      margin: 0 auto 0 rem(5);

      &:hover {
        background-color: rgba($primary, 0.8);
        color: $light;
      }
    }
  }

  &__component {
    display: flex;
    flex-flow: column nowrap;

    @include breakpoint(desktop) {
      flex-flow: row nowrap;
    }
  }
}
</style>
